module.exports = __webpack_public_path__ + "img/download-csv.3373395d.svg";